import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { REDUCER, ACTION } from "@common/constants/redux";

const initialState = { filter: null };

const persistConfig = {
  key: REDUCER.NOTIFICATION_CAMPAIGN,
  storage: storage,
};

const notificationCampainReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case ACTION.SET_NOTIFICATION_CAMPAIGN_FILTER:
    return {
      ...state,
      filter: payload,
    };
  default:
    return state;
  }
};

export default persistReducer(persistConfig, notificationCampainReducer);
